import { Controller } from "@hotwired/stimulus";

// Attached to the enable form. Enabling creates any missing confirmation messages, so when the server
// passes a confirm message the admin is asked first; cancelling puts the switch back without submitting.
export default class extends Controller {
  static values = { confirmMessage: String };

  submit(event) {
    const input = event.target;
    const enabling = input.value === "true";

    if (enabling && this.hasConfirmMessageValue && !window.confirm(this.confirmMessageValue)) {
      this.revert(input);
    } else {
      this.element.requestSubmit();
    }
  }

  revert(input) {
    const wrapper = input.closest("[data-controller='ui--switch']");
    input.value = "false";
    wrapper.dataset.state = "unchecked";
    wrapper.querySelector("button").dataset.state = "unchecked";
    wrapper.querySelector("button").setAttribute("aria-checked", "false");
    wrapper.querySelector("span").dataset.state = "unchecked";
  }
}
